import { Component, Input, ViewEncapsulation } from '@angular/core';
import { expandFadeInFadeOutCollapseAnimation } from '../../../../../shared/animations/index';

@Component({
  selector: 'list-filter-panel',
  standalone: false,
  templateUrl: './list-filter-panel.component.html',
  styleUrls: ['./list-filter-panel.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  encapsulation: ViewEncapsulation.None,
  animations: [expandFadeInFadeOutCollapseAnimation],
})
export class ListFilterPanelComponent {
  @Input() heading: string;

  get bodyAnimationState() {
    return this.displayBody ? 'expanded' : 'collapsed';
  }

  displayBody: boolean = false;

  handleHeaderClick() {
    this.toggleDisplayBody();
  }

  toggleDisplayBody() {
    this.displayBody = !this.displayBody;
  }
}
